import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent } from '@/components/ui/card';
import { toast } from 'sonner';

import usePageTitle from '@/hooks/usePageTitle';
export default function ForgotPassword() {
  usePageTitle('Forgot password');
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const { resetPassword } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await resetPassword(email);
      setSent(true);
      toast.success('Reset link sent. Check your inbox.');
    } catch (err) {
      toast.error(err.message || 'Could not send reset email.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-background bg-hero-soft text-foreground flex items-center justify-center p-6">
      <Card className="w-full max-w-md rounded-2xl border-border/70">
        <CardContent className="p-6 sm:p-8 space-y-5">
          <div>
            <div className="font-display text-2xl font-semibold">Reset your password</div>
            <div className="text-sm text-muted-foreground mt-1">We’ll email you a calm, simple link.</div>
          </div>
          {sent ? (
            <div className="text-sm text-muted-foreground" data-testid="forgot-sent-message">If an account exists for {email}, a reset link is on its way.</div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="auth-email-input" className="rounded-xl" />
              </div>
              <Button type="submit" className="w-full rounded-xl" disabled={busy} data-testid="forgot-submit-button">
                {busy ? 'Sending…' : 'Send reset link'}
              </Button>
            </form>
          )}
          <div className="text-sm text-muted-foreground">
            Remembered? <Link to="/login" className="text-primary hover:underline">Back to sign in</Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
